<template>
  <div class="zw-menu-sep" role="separator" aria-hidden="true" />
</template>

<style>
.zw-menu-sep {
  height: 1px;
  margin: 0.25rem 0.35rem;
  background: var(--line);
}
</style>
